// import React from "react";
// import styles from "./Footer.module.css";
// import Download from "../Download";
// import { Link } from "react-router-dom";
// import logo from "../../assets/images/logo.png";

// const Footer = () => {
//   return (
//     <footer className={styles.siteFooter}>
//       <div className={styles.footerParticlesContainer}>
//         <canvas id="footer-particles"></canvas>
//       </div>

//       <div className={styles.siteFooterTop}>
//         <section className={styles.cta}>
//           <div className={styles.containerSm}>
//             <div className={styles.ctaInner}>
//               <div className={styles.ctaHeader}>
//                 <h2 className={styles.sectionTitle}>Stay in the know</h2>
//                 <p className={styles.sectionParagraph}>
//                   Don’t miss a deal! Download I ❤️ Sambhal App and start exploring local
//                   offers, earning rewards, and unlocking exclusive discounts —
//                   right from your phone.
//                 </p>
//                 {/* <div className={styles.ctaCta}>
//                   <a className={styles.buttonPrimary} href="#">Get early access</a>
//                 </div> */}
//                 {/* <div className={styles.downloadButtons}>
//                   <a
//                     href="#"
//                     className={styles.storeButton}
//                     aria-label="Download on App Store"
//                   >
//                     <img src="/images/app-store.png" alt="Download on the App Store" />
//                   </a>
//                   <a
//                     href="#"
//                     className={styles.storeButton}
//                     aria-label="Download on Google Play"
//                   >
//                     <img src="/images/play-store.png" alt="Get it on Google Play" />
//                   </a>
//                 </div> */}
//                 <Download />
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>

//       {/* <div className={styles.siteFooterBottom}>
//         <div className={styles.container}>
//           <div className={styles.siteFooterInner}>
//             <div className={styles.brand}>
//               <a href="#">
//                 <img src={logo} className="h-14" alt="FootFall logo" />
//               </a>
//             </div>
//             <ul className={styles.footerLinks}>
//               <li>
//                 <Link to="/privacy-policy">Privacy Policy</Link>
//               </li>
//               <li>
//                 <Link to="/delete-account">Delete Account</Link>
//               </li>
//             </ul>
            
//           </div>
//         </div>
//       </div>

//       <div className={styles.footerCopyright}>
//         &copy; 2025 FootFall, All Rights Reserved
//       </div> */}

//       <div className={styles.siteFooterBottom}>
//         <div className={styles.container}>
//           <div className={styles.siteFooterInner}>
//             <div className={styles.brand}>
//               <a href="#">
//                 {/* <img src={logo} className="h-14" alt="FootFall logo" /> */}
//                 <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 dark:text-white whitespace-nowrap">
//                   I ❤️ Sambhal
//                 </h1>
//               </a>
//             </div>
//             <ul className={styles.footerLinks}>
//               <li>
//                 <Link to="/support">Support</Link>
//               </li>
//               <li>
//                 <Link to="/privacy-policy">Privacy Policy</Link>
//               </li>
//               <li>
//                 <Link to="/delete-account">Delete Account</Link>
//               </li>
//             </ul>
//           </div>

//           {/* Move copyright inside siteFooterBottom but outside siteFooterInner */}
//           <div className={styles.footerCopyright}>
//             &copy; 2025 I ❤️ Sambhal, All Rights Reserved
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;




import React from "react";
import styles from "./Footer.module.css";
import Download from "../Download";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className={styles.siteFooter}>
      <div className={styles.footerParticlesContainer}>
        <canvas id="footer-particles"></canvas>
      </div>

      <div className={styles.siteFooterTop}>
        <section className={styles.cta}>
          <div className={styles.containerSm}>
            <div className={styles.ctaInner}>
              <div className={styles.ctaHeader}>
                <h2 className={styles.sectionTitle}>
                  {t("footer.stayInTheKnow.title")}
                </h2>
                <p className={styles.sectionParagraph}>
                  {t("footer.stayInTheKnow.description")}
                </p>
                <Download />
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className={styles.siteFooterBottom}>
        <div className={styles.container}>
          <div className={styles.siteFooterInner}>
            <div className={styles.brand}>
              <a href="#">
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 dark:text-white whitespace-nowrap">
                  {/* I ❤️ Sambhal */}
                  {t("title")}
                </h1>
              </a>
            </div>
            <ul className={styles.footerLinks}>
              <li>
                <Link to="/support">{t("footer.links.support")}</Link>
              </li>
              <li>
                <Link to="/privacy-policy">{t("footer.links.privacyPolicy")}</Link>
              </li>
              <li>
                <Link to="/delete-account">{t("footer.links.deleteAccount")}</Link>
              </li>
            </ul>
          </div>

          <div className={styles.footerCopyright}>
            &copy; 2025 {t("title")}, {t("footer.copyright")}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
